/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { EduHatIcon16Light } from './EduHatIcon16Light';
import { EduHatIcon16Regular } from './EduHatIcon16Regular';
import { EduHatIcon16Solid } from './EduHatIcon16Solid';
import { EduHatIcon20Light } from './EduHatIcon20Light';
import { EduHatIcon20Regular } from './EduHatIcon20Regular';
import { EduHatIcon20Solid } from './EduHatIcon20Solid';
import { EduHatIcon24Regular } from './EduHatIcon24Regular';
import { EduHatIcon24Solid } from './EduHatIcon24Solid';
import { EduHatIcon32Regular } from './EduHatIcon32Regular';
import { EduHatIcon64Regular } from './EduHatIcon64Regular';
var sizes = {
    16: {
        light: EduHatIcon16Light,
        regular: EduHatIcon16Regular,
        solid: EduHatIcon16Solid,
    },
    20: {
        light: EduHatIcon20Light,
        regular: EduHatIcon20Regular,
        solid: EduHatIcon20Solid,
    },
    24: {
        regular: EduHatIcon24Regular,
        solid: EduHatIcon24Solid,
    },
    32: {
        regular: EduHatIcon32Regular,
    },
    64: {
        regular: EduHatIcon64Regular,
    },
};
export var EduHatIcon = forwardRef('EduHatIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
